import { Paper } from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";
import React from "react";
import { useSelector } from "react-redux";
import muiConfig from '../../assets/MuiConfig.json'

export default function KPIDashboard() {
  const state = useSelector((store) => store.dashboard);
  const { orderStatus } = state;
  const columns = [
    { field: "col1", headerName: "Country", flex: 1 },
    { field: "col2", headerName: "Quota Modifications", flex: 1, align: "center",headerAlign: "center" },
    { field: "col3", headerName: "Orders on Block", flex: 1, align: "center",headerAlign: "center" },
    { field: "col4", headerName: "Delivered Fully", flex: 1, align: "center",headerAlign: "center" },
    { field: "col5", headerName: "Delivered Partially", flex: 1, align: "center",headerAlign: "center" },
    { field: "col6", headerName: "Fully Declined", flex: 1, align: "center",headerAlign: "center" },
  ];

  const rows = prepareRows();

  function prepareRows() {
    let rows = [];
    for (let i = 0; i < orderStatus.length; ++i) {
      let obj = orderStatus[i];
      let item = {
        id: orderStatus[i].geoId,
        col1: orderStatus[i].geoName,
        col2: orderStatus[i].modified_Quota,
        col3: orderStatus[i].blocked_Orders,
        col4: orderStatus[i].delivered_Fully,
        col5: orderStatus[i].delivered_Partially,
        col6: orderStatus[i].fully_Declined,
      };
      rows.push(item);
    }
    return rows;
  }
  return (
    <Paper elevation={0}>
      <DataGridPro
        style={{ maxHeight: "calc(80vh - 110px)" }}
        disableColumnMenu
        sx={{
          "& .MuiDataGrid-columnHeaderTitle": {
            whiteSpace: "normal",
            lineHeight: "normal",
          },
          "& .MuiDataGrid-columnHeader": {
            position: "sticky",
          },
          "& .MuiDataGrid-columnHeaders": {
            maxHeight: "168px !important",
          },
        }}
        rowHeight={70}
        rows={rows || []}
        columns={columns}
        initialState={{
          pagination: { paginationModel: { pageSize:20, page:0 }}
        }}
        pagination
        pageSizeOptions={[20, 50, 100, { value: muiConfig.DataGrid_All , label: 'All' }]}
        disableRowSelectionOnClick
      />
    </Paper>
  );
}
